import { RESET_SESSION_TIMER } from "../actions/timer";

const initialState = {
  sessionExpiresAt: null,
};

export default function timer(state = initialState, action) {
  switch (action.type) {
    case RESET_SESSION_TIMER:
      return {
        ...state,
        sessionExpiresAt: action.payload,
      };
    default:
      return state;
  }
}
